// File: src/components/reveal/RevealPortalNavBar.jsx
import React, { useState, useEffect } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { FaUsers } from 'react-icons/fa';
import { ReactComponent as TribeLogo } from '../../assets/TribeLogo.svg';
import axios from 'axios';
import EventHelpToolTipLeft from '../mixer/Color Mixer UI Components/EventHelpToolTipLeft'

/* ───────── STYLES ───────── */
const S = {
  wrapper: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    background: '#fff',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
  },
  navRow: {
    height: 55,
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
  },

  /* Left slot */
  leftSlot: {
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
    height: 28,
  },

  exitBtn: {
    padding: '6px 14px',
    borderRadius: 999,
    border: '1px solid #e5e7eb',
    background: '#fff',
    fontWeight: 700,
    fontSize: '0.85rem',
    color: '#0f172a',
    cursor: 'pointer',
  },

  /* Center logo — absolute true center */
  logoCenter: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  logo: { width: 72, height: 'auto' },

  /* Right occupancy pill */
  occPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    background: '#f8fafc',
    color: '#475569',
    border: '1px solid #e5e7eb',
    borderRadius: 9999,
    padding: '0px 10px',
    fontSize: '0.8rem',
    fontWeight: 600,
    lineHeight: 1,
    height: 28,
    zIndex: 1,
  },
  occIcon: { fontSize: 12, opacity: 0.85 },
};

export default function RevealPortalNavBar({
  eventId,
  helpTitle = 'Need a hand?',
  helpBody = 'Quick tips for this step. If you get stuck, follow the on-screen prompts.',
}) {
  const [count, setCount] = useState(0);
  const location  = useLocation();
  const params    = useParams();
  const navigate  = useNavigate();

  const resolvedEventId = String(eventId || params.eventId || '').trim();

  // Detect if we’re on portal page
  const isPortalPage = /\/reveal\/[^/]+\/portal/i.test(location.pathname || '');

  useEffect(() => {
    if (!resolvedEventId) return;
    let id;
    const fetchOccupancy = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/events/${resolvedEventId}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
        );
        const c = Number(
          data?.presentCount ?? data?.occupancyCount ?? data?.registeredCount ?? 0
        );
        setCount(Number.isFinite(c) ? c : 0);
      } catch (err) {
        if (err?.response?.status === 410) {
          clearInterval(id);
          setCount(0);
          return;
        }
      }
    };

    fetchOccupancy();
    id = setInterval(fetchOccupancy, 5000);
    return () => clearInterval(id);
  }, [resolvedEventId]);

  return (
    <div style={S.wrapper}>
      <div style={S.navRow}>
        {/* Left: Exit if portal, Tooltip otherwise */}
        <div style={S.leftSlot}>
          {isPortalPage ? (
            <button
              type="button"
              onClick={() => navigate(`/events/${resolvedEventId}`)}
              style={S.exitBtn}
            >
              Exit
            </button>
          ) : (
            <EventHelpToolTipLeft title={helpTitle} body={helpBody} />
          )}
        </div>

        {/* Center logo */}
        <div style={S.logoCenter}>
          <TribeLogo style={S.logo} />
        </div>

        {/* Right: Occupancy */}
        <div style={S.occPill} aria-label="Occupancy">
          <FaUsers style={S.occIcon} />
          <span>{count}</span>
        </div>
      </div>
    </div>
  );
}
